import { Link} from 'react-router-dom';




const Navbar = () => {



    return (
        <nav className="navbar">
            <h1>Maths Brisbane</h1>
            <div className="links">
                <Link to="/">Home</Link>
                <Link to="/students">Students</Link>
                <Link to="/teachers">Teachers</Link>
                <Link to="/allvideos">All Videos</Link>
            </div>
        </nav>
    );
}

export default Navbar;